import React from "react";
import "./Contact.scss";
import Envelope from "../../assets/kontakt_img.png";
import { INSTAGRAM_LINK } from "../../constants";

const Contact = () => {
  return (
    <div className="main">
      <div className="contact-container">
        <div className="contact-info">
          <strong>E-mail: </strong>
          <a href="mailto:ve.kubosova@gmail.com">ve.kubosova@gmail.com</a>
        </div>

        <div>
          <strong>Instagram: </strong>
          <a href={INSTAGRAM_LINK} target="_blank" rel="noreferrer">
            @veronika_kubosova
          </a>
        </div>
        <img src={Envelope} alt="Envelope" className="envelope" />
      </div>
    </div>
  );
};

export default Contact;
